import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './reducers'
import { thunk } from 'redux-thunk'

import createSagaMiddleware from 'redux-saga'
import {
  watchAuth,
  watchOrganization,
  watchAccount,
  watchAudience,
  watchCampaign,
  watchTemplate,
  watchStats
} from './sagas'

const sagaMiddleware = createSagaMiddleware()

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(thunk, sagaMiddleware),
  devTools: process.env.REACT_APP_ENV !== 'production'
})

sagaMiddleware.run(watchAuth)
sagaMiddleware.run(watchOrganization)
sagaMiddleware.run(watchAccount)
sagaMiddleware.run(watchAudience)
sagaMiddleware.run(watchCampaign)
sagaMiddleware.run(watchTemplate)
sagaMiddleware.run(watchStats)
